import {
  useFxWorkspaceContext,
  type FxBreaklineType,
} from '@mobile-mapping/providers';
import { t } from '@trimble/i18n';
import { BtnClasses, IconButton } from '@tcweb/connect-ui';
import { Component, JSX } from 'solid-js';

export interface FxBreaklineTypeRowActionsProps {
  readonly workspaceId: string;
  readonly breaklineType: FxBreaklineType;
}

export const FxBreaklineTypeRowActions: Component<
  FxBreaklineTypeRowActionsProps
> = (props): JSX.Element => {
  const fxWorkspace = useFxWorkspaceContext();

  const stopTreeRowInteraction = (event: Event): void => {
    event.stopPropagation();
  };

  const handlePublish = (event: MouseEvent): void => {
    stopTreeRowInteraction(event);
    fxWorkspace.publishBreakline(props.workspaceId, props.breaklineType);
  };

  return (
    <div
      class="flex items-center gap-1 pr-2"
      onPointerDown={stopTreeRowInteraction}
    >
      <IconButton
        color={BtnClasses.TERTIARY}
        icon="tc-icon-launch"
        size="icon-medium"
        data-cy={`fx-breakline-publish-${props.workspaceId}-${props.breaklineType}`}
        title={t('mobileMapping.fxWorkspace.breaklines.publish')}
        clicked={handlePublish}
      />
    </div>
  );
};
